export default __webpack_public_path__ + "static/media/3861.f36036bb.png";